module.exports = __webpack_public_path__ + "img/z16.c68bcfdc.png";